<template>
  <el-row class="warp">
	<!--工具条-->
  	<el-col :span="24" class="toolbar">
  	  <el-form :inline="true" :model="filters" ref="filtersForm">
  	    <el-form-item label="设备短号" prop="deviceShortcode">
  	      <el-input v-model.trim="filters.deviceShortcode" placeholder="设备短号"></el-input>
  	    </el-form-item>
  	    <el-form-item>
  	      <el-button type="primary" @click="handleSearch">查询</el-button>
  	      <el-button type="primary" @click="resetForm('filtersForm')">重置</el-button>
  	      <el-button type="primary" @click="showAddDialog" v-has-permission="'project:add'">新增</el-button>
  	      <el-button type="primary" @click="templateDownload">导入模板下载</el-button>
          <el-button type="primary" @click="showUploadDialog">导入</el-button>
  	    </el-form-item>
  	  </el-form>
  	</el-col>
  	<!--列表-->
  	<el-table :data="deviceDatas" highlight-current-row border style="width: 100%;">
  	  <el-table-column type="index" width="60" align="center" fixed="left"></el-table-column>
      <el-table-column prop="deviceName" label="设备名称" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="deviceCode" label="设备号" width="160" sortable></el-table-column>
  	  <el-table-column prop="deviceShortcode" label="设备短号" width="150" sortable></el-table-column>
  	  <el-table-column prop="deviceSn" label="设备型号" width="110" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="deviceSupplierCategoryName" label="供应商设备品类" width="150" show-overflow-tooltip sortable></el-table-column>
      <el-table-column prop="deviceSupplierName" label="供应商" width="200" show-overflow-tooltip sortable></el-table-column>
  	  <el-table-column prop="provinceName" label="省" width="120" sortable></el-table-column>
  	  <el-table-column prop="cityName" label="市" width="120" sortable></el-table-column>
  	  <el-table-column prop="districtName" label="区/县" width="120" sortable></el-table-column>
  	  <el-table-column prop="addressDetail" label="详细地址" width="250" show-overflow-tooltip sortable></el-table-column>
  	  <el-table-column prop="devicePosition" label="位置" width="120" show-overflow-tooltip sortable></el-table-column>
  	  <el-table-column prop="installDate" label="安装日期" width="110" sortable></el-table-column>
  	  <el-table-column prop="remark" label="备注" width="180" show-overflow-tooltip sortable></el-table-column>
  	  <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)" v-has-permission="'device:update'">编辑</el-button>
          <el-button type="danger" size="mini" @click="remove(scope.$index,scope.row)" v-has-permission="'device:delete'">删除</el-button>
        </template>
      </el-table-column>
  	</el-table>
    <!--分页工具栏-->
    <el-col :span="24" class="toolbar">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
      :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
      </el-pagination>
    </el-col>
    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" @open="onAddDialogOpen" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="130px" :rules="formRules" ref="addForm">
      	<el-input v-model="addForm.projectId" type="hidden"></el-input>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备短号" prop="deviceShortcode">
              <el-input v-model="addForm.deviceShortcode" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input v-model="addForm.deviceName" placeholder="请输入内容" maxlength="30" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          	<el-form-item label="设备号" prop="deviceCode">
              <el-input v-model="addForm.deviceCode" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备供应商" prop="deviceSupplierId">
              <el-select v-model="addForm.deviceSupplierId" @change="handleSupplierChange" filterable placeholder="请选择" style="width:100%;">
                <el-option
                  v-for="item in deviceSuppliers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商设备品类" prop="deviceSupplierCategoryId">
              <el-select v-model="addForm.deviceSupplierCategoryId" @change="handleSupplierCategoryChange" clearable placeholder="请选择" style="width:100%;">
                  <el-option v-for='(item,index) in deviceSupplierCategoryDatas' :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备型号" prop="deviceSn">
              <el-input v-model="addForm.deviceSn" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-form-item label="省市区">
            <el-col :span="7">
              <el-form-item prop="provinceCode">
                <el-select v-model="addForm.provinceCode" @change="handleProvinceChange" clearable placeholder="请选择">
                  <el-option
                    v-for="item in provinceDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="cityCode">
                <el-select v-model="addForm.cityCode" @change="handleCityChange" clearable placeholder="请选择">
                  <el-option
                    v-for="item in cityDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="districtCode">
                <el-select v-model="addForm.districtCode" @change="handleDistrictChange" clearable placeholder="请选择">
                  <el-option
                    v-for="item in districtDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="addressDetail">
              <el-input v-model="addForm.addressDetail" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="位置" prop="devicePosition">
              <el-input v-model="addForm.devicePosition" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度" prop="deviceLongitude">
              <el-input v-model="addForm.deviceLongitude" placeholder="请输入内容" maxlength="15" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="deviceLatitude">
              <el-input v-model="addForm.deviceLatitude" placeholder="请输入内容" maxlength="15" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="安装日期" prop="deviceRegisterTime">
              <el-date-picker type="date" v-model="addForm.installDate" placeholder="请选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" v-model="addForm.remark" :rows="3" placeholder="请输入内容" maxlength="100" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="loading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" @open="onEditDialogOpen" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="130px" :rules="formRules" ref="editForm">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-input v-model="editForm.projectId" type="hidden"></el-input>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备短号" prop="deviceShortcode">
              <el-input v-model="editForm.deviceShortcode" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input v-model="editForm.deviceName" placeholder="请输入内容" maxlength="30" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          	<el-form-item label="设备号" prop="deviceCode">
              <el-input v-model="editForm.deviceCode" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备供应商" prop="deviceSupplierId">
              <el-select v-model="editForm.deviceSupplierId" @change="handleSupplierChange" filterable placeholder="请选择" style="width:100%;">
                <el-option
                  v-for="item in deviceSuppliers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商设备品类" prop="deviceSupplierCategoryId">
              <el-select v-model="editForm.deviceSupplierCategoryId" @change="handleSupplierCategoryChange" clearable placeholder="请选择" style="width:100%;">
                  <el-option v-for='(item,index) in deviceSupplierCategoryDatas' :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备型号" prop="deviceSn">
              <el-input v-model="editForm.deviceSn" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-form-item label="省市区">
            <el-col :span="7">
              <el-form-item prop="provinceCode">
                <el-select v-model="editForm.provinceCode" @change="handleProvinceChange" clearable placeholder="请选择">
                  <el-option
                    v-for="item in provinceDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="cityCode">
                <el-select v-model="editForm.cityCode" @change="handleCityChange" clearable placeholder="请选择">
                  <el-option
                    v-for="item in cityDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="districtCode">
                <el-select v-model="editForm.districtCode" @change="handleDistrictChange" clearable placeholder="请选择">
                  <el-option
                    v-for="item in districtDatas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="addressDetail">
              <el-input v-model="editForm.addressDetail" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="位置" prop="devicePosition">
              <el-input v-model="editForm.devicePosition" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度" prop="deviceLongitude">
              <el-input v-model="editForm.deviceLongitude" placeholder="请输入内容" maxlength="15" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="deviceLatitude">
              <el-input v-model="editForm.deviceLatitude" placeholder="请输入内容" maxlength="15" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="安装日期" prop="deviceRegisterTime">
              <el-date-picker type="date" v-model="editForm.installDate" placeholder="请选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" v-model="editForm.remark" :rows="3" placeholder="请输入内容" maxlength="100" show-word-limit auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="loading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="上传" :visible.sync="uploadDialogVisible" @open="onUploadDialogOpen" :close-on-click-modal="false">
      <el-upload 
        ref="upload"
        name="uploadFiles"
        action="/api/device/upload/template"
        accept=".xlsx"
        :data="uploadParams"
        :auto-upload="false" 
        :file-list="fileList"
        :limit="1" 
        :on-exceed="handleExceed"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :on-error="handleError"
        :before-upload="beforeUpload">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <div slot="tip" class="el-upload__tip">只能上传Excel文件，且不超过5M</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import { saveAs } from 'file-saver';
import REGION_API from '../../../api/api_region';
import DEVICE_API from '../../../api/api_device';

export default {
  created () {
    let that = this;
    let params = {};

    this.handleSearch();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'handleSearch'
  },
  data() {
  	let that = this;
  	var checkDevice = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入设备短号'));
        return;
      }
      var params = {
      	projectId: this.$route.params.id,
        deviceShortcode: value
      }
      if (that.editFormVisible) {
        params = Object.assign(params, {
          id: that.editForm.id
        });
      }
      DEVICE_API.checkDevice(params)
      .then(
        function(result) {
          if (result && result.code == 200 
            && result.data && result.data === true) {
              callback(new Error('设备短号重复'));
              return;
          }
          callback();
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
          callback();
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
        callback();
      });
    };
    return {
      loading: false,
      filters: {},

      // 分页参数
      total: 0,
      page: 1,
      limit: 10,
      deviceDatas: [],
      deviceSuppliers:[],
      provinceDatas: [],
      cityDatas: [],
      districtDatas: [],
      deviceSupplierCategoryDatas: [],

      // 新增/编辑相关数据
      addFormVisible: false,//新增界面是否显示
      editFormVisible: false,//编辑界面是否显示
      uploadDialogVisible: false,//上传界面是否显示
      addForm: {},
      editForm: {},
      formRules: {
        deviceShortcode: [
          {required: true, message: '请输入设备短号', trigger: 'blur'},
          {validator: checkDevice, trigger: 'blur'}
        ],
        deviceName:[
          {required: true, message: '请输入设备名称', trigger: ['blur','change']}
        ],
        deviceCode: [
          {required: true, message: '请输入设备号', trigger: ['blur','change']}
        ],
        deviceSupplierId: [
          {required: true, message: '请选择设备供应商', trigger: 'blur'},
        ],
        deviceSupplierCategoryId: [
          {required: true, message: '请选择供应商设备品类', trigger: 'blur'},
        ]
      },

      //文件上传
      uploadParams: {
        projectId: this.$route.params.id,
        deviceCategoryId: this.$route.params.deviceCategoryId
      },
      fileList: []
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleSearch();
    },
    search() {
      let that = this;
      let params = Object.assign({
      	projectId: this.$route.params.id,
      	deviceCategoryId: this.$route.params.deviceCategoryId,
        page: that.page,
        limit: that.limit,
      }, that.filters);
      DEVICE_API.devicePageList(params)
      .then(
        function(result){
          if (result && result.code == 200) {
            that.total = result.data.total;
            that.deviceDatas = result.data.records;
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    loadRegion: function(code, callback) {
      let that = this;
      REGION_API.childrens(code)
      .then(
        function(result){
          if (result && result.code == 200) {
            if (typeof callback === 'function') {
              callback(result.data);
            }
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常!',
          duration: 2000
        });
      });
    },
    handleProvinceChange: function() {
      let that = this;
      let form = this.addFormVisible ? this.addForm: this.editForm;
      form.cityCode = '';
      form.districtCode = '';
      this.cityDatas = [];
      this.districtDatas = [];
      if (form.provinceCode === '') {
        return;
      }
      this.loadRegion(form.provinceCode, function(data){
        that.cityDatas = data;
      });
    },
    handleCityChange: function() {
      let that = this;
      let form = this.addFormVisible ? this.addForm: this.editForm;
      form.districtCode = '';
      this.districtDatas = [];
      if (form.cityCode === '') {
        return;
      }
      this.loadRegion(form.cityCode, function(data){
        that.districtDatas = data;
      });
    },
    handleDistrictChange: function() {
      this.$forceUpdate();
    },
    supplierList: function () {
      let that = this;
      DEVICE_API.allSupplier()
      .then(
        function(result){
          if (result && result.code == 200) {
            that.deviceSuppliers = result.data;
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常!',
          duration: 2000
        });
      });
    },
    handleSupplierChange: function(value){
      let that = this;
      let form = this.addFormVisible? this.addForm: this.editForm;
      this.$delete(form,'deviceSupplierCategoryId');
      this.$delete(form,'deviceSn');
      this.deviceSupplierCategoryCombox(value);
    },
    //供应商设备品类change事件
    handleSupplierCategoryChange(value) {
        let supplierCategory = this.deviceSupplierCategoryDatas.find(item => item.id == value);
        let form = this.addFormVisible? this.addForm: this.editForm;
        form.deviceSn = supplierCategory.type;
    },
    deviceSupplierCategoryCombox: function(supplierId){
      let that = this;
      DEVICE_API.deviceSupplierCategoryCombox(supplierId)
      .then(
        function(result){
          if (result && result.code == 200) {
            let deviceSupplierCategoryDatas = [];
            result.data.forEach(function(item){
              if (item.categoryId === that.$route.params.deviceCategoryId) {
                deviceSupplierCategoryDatas.push(item);
              }
            });
            that.deviceSupplierCategoryDatas = deviceSupplierCategoryDatas;
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常!',
          duration: 2000
        });
      });
    },
    showAddDialog: function () {
      let that = this;
      this.addForm = {};
      this.deviceSupplierCategoryDatas = [];
      this.addFormVisible = true;
      this.addForm.projectId = this.$route.params.id;
      this.supplierList();
      this.loadRegion('000000', function(data){
        that.provinceDatas = data;
      });
    },
    onAddDialogOpen: function() {
      this.$nextTick(() => {
        this.$refs['addForm'].clearValidate();
      });
    },
    //新增
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.addForm);
          DEVICE_API.saveDevice(params)
          .then(
            function(result){
              that.loading = false;
              if (result && result.code == 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '新增成功!',
                  duration: 2000
                });
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.handleSearch();
              } else {
                that.$message.error({
                  showClose: true,
                  message: '新增失败!',
                  duration: 2000
                });
              }
            },
            function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        }
      });
    },
    //显示编辑界面
    showEditDialog: function (index, row) {
      let that = this;
      //避免源对象row被修改
      var newRow = JSON.parse(JSON.stringify(row));
      this.editForm = Object.assign({}, newRow);
      this.editForm.projectId = this.$route.params.id;
      this.supplierList();
      this.deviceSupplierCategoryCombox(that.editForm.deviceSupplierId);
      this.loadRegion('000000', function(data){
        that.provinceDatas = data;
      });
      this.loadRegion(this.editForm.provinceCode, function(data){
        that.cityDatas = data;
      });
      this.loadRegion(this.editForm.cityCode, function(data){
        that.districtDatas = data;
      });
      this.editFormVisible = true;
    },
    onEditDialogOpen: function() {
      this.$nextTick(() => {
         this.$refs['editForm'].clearValidate();
      });
    },
    //编辑
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.editForm);
          DEVICE_API.updateDevice(params)
          .then(
            function(result){
              that.loading = false;
              if (result && result.code == 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '修改成功!',
                  duration: 2000
                });
                that.$refs['editForm'].resetFields();
                that.editFormVisible = false;
                that.handleSearch();
              } else {
                that.$message.error({
                  showClose: true,
                  message: '修改失败!',
                  duration: 2000
                });
              }
            },
            function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        }
      });
    },
    //删除
    remove: function (index, row) {
      let that = this;
      this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
        that.loading = true;
        DEVICE_API.removeDevice(row.id)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code === 200 
              && result.data && result.data === true) {
              that.$message.success({
                showClose: true,
                message: '删除成功',
                duration: 1500
              });
              that.search();
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      })
      .catch(() => {
      });
    },
    templateDownload: function() {
      let that = this;
      DEVICE_API.downloadTemplate()
      .then(
        function (result) {
          let fileName = 'DeviceImportTemplate.xlsx'; //下载后文件名
          let blob = new Blob([result], { type: 'application/vnd.ms-excel;charset=utf-8'});
          saveAs(blob, fileName);
        }, 
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    showUploadDialog: function () {
      this.uploadParams = Object.assign({}, {
        projectId: this.$route.params.id,
        deviceCategoryId: this.$route.params.deviceCategoryId,
        importDataType: 0  // 导入数据类型  0：设备导入 1：点位导入
      });
      this.uploadDialogVisible = true;
    },
    onUploadDialogOpen: function(){
      this.$nextTick(() => {
         this.$refs['upload'].clearFiles();
      });
    },
    beforeUpload: function(file) {
      // application/vnd.ms-excel => .xls后缀
      // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet => .xlsx后缀
      const isEXCEL = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt100M = file.size / 1024 / 1024 <= 100;

      if (!isEXCEL) {
        this.$message.error('上传文件只支持XLSX后缀EXCEL文件格式!');
        return false;
      }
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过100MB!');
        return false;
      }
      this.loading = true;
    },
    submitUpload: function() {
      this.$refs.upload.submit();
    },
    handleExceed: function(files, fileList){
      this.$message.error('文件上传数量一次不能超过1个!');
    },
    handleRemove: function(file, fileList) {
      //console.log(file, fileList);
    },
    handlePreview: function(file) {
      //console.log(file);
    },
    handleSuccess: function(response, file, fileList){
      this.loading = false;
      if (response && response.code === 200){
        this.uploadDialogVisible = false;
        this.handleSearch();
        return;
      }
      
      this.$message.error(response.msg);
    },
    handleError: function(err, file, fileList){
      this.loading = false;
    }

  }
};
</script>


// WEBPACK FOOTER //
// CommonTemplate.vue?2692b43b